import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=2a022281&scoped=true&"
import script from "./TheNavbar.vue?vue&type=script&lang=js&"
export * from "./TheNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=2a022281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a022281",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a022281')) {
      api.createRecord('2a022281', component.options)
    } else {
      api.reload('2a022281', component.options)
    }
    module.hot.accept("./TheNavbar.vue?vue&type=template&id=2a022281&scoped=true&", function () {
      api.rerender('2a022281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/TheNavbar.vue"
export default component.exports